export const typeOptions = [
  {
    title: "图片靠左",
    type: "left"
  },
  {
    title: "图片靠右",
    type: "right"
  }
];

export const radioOptions = [
  {
    label: "显示",
    value: true
  },
  {
    label: "不显示",
    value: false
  }
];



// WEBPACK FOOTER //
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/articleComponents/Article/options.js